import(/* webpackMode: "eager" */ "/codebuild/output/src453302789/src/src/app/global-error.tsx");
